<template>
	<j-card v-if="course" class="xs-12 p4 bg5">
		<course-detail-input-field
			componentName="j-base-input-text"
			class="mb4"
			:label="$t('course_title')"
			name="course_title"
			v-model="course.name"
			@blur="handleFieldUpdate('name')"
		/>
		<course-detail-input-field
			componentName="j-base-input-long-text"
			class="mb4"
			:label="$t('description')"
			name="description"
			v-model="course.description"
			@blur="handleFieldUpdate('description')"
		/>
		<course-detail-input-field
			componentName="j-base-input-text"
			class="mb4"
			:label="$t('version')"
			name="version"
			v-model="course.version"
			@blur="handleFieldUpdate('version')"
		/>
		<course-detail-input-field
			componentName="input-categories-list"
			class="mb4"
			size="xsmall"
			:label="$t('categories')"
			name="featured"
			v-model="course.categories"
			@input="handleFieldUpdate('categories')"
		/>
	</j-card>
</template>

<script>
import CourseDetailInputField from "./CourseDetailInputField"
import JCard from "@/components/JCard"

import api from "@/api/gql.js"

import queries from "../utils/queries.js"

export default {
	components: {
		CourseDetailInputField,
		JCard
	},

	props: {
		course: Object,

		selectedLocale: String
	},

	data() {
		return {
			form: {
				name: null,
				description: null,
				version: null,
				categories: null
			},
			schema: null
		}
	},

	computed: {
		courseId() {
			return this.course.id
		}
	},

	methods: {
		onInputSchema(payload) {
			this.schema = payload
		},

		async handleFieldUpdate(field) {
			if (!this.course[field]) return
			let apiKey, query, variables
			// Upsert l10n key if name or description ; update course if lenght or categories
			if (field === "name" || field === "description") {
				variables = {
					l10n: {
						key: `courses-${this.course?.id}-${field}`,
						locale: this.selectedLocale,
						value: this.course[field]
					}
				}
				apiKey = "upsertL10n"
				query = queries.upsertL10n
			} else {
				variables = {
					id: this.course?.id,
					input: {
						[field]: this.course[field]
					}
				}
				apiKey = "updateCourse"
				query = queries.updateCourse
			}

			const res = await api({ query, variables })
			this.isLoading = false

			if (res?.data[apiKey]?.status !== "success") {
				this.$store.dispatch("addMessage", {
					message: {
						type: "error",
						text: this.$t("errors.general")
					}
				})
				return
			}

			this.$emit("course:updated")
		}
	}
}
</script>
